import type { DeepPartial } from '@luna/utils-ts';

import type { OwnTransfer } from './OwnTransfer';

export const AT: DeepPartial<OwnTransfer> = {
    enabledForLoans: true,
    descriptionAttributeMapping: 'additionalInfo.text4x35[0]',
    descriptionMaxLength: 35,
    isSecondarySigneeSelectDisplayed: true,
    isSFondsInfoDisplayed: true,
    shouldCheckForPenaltyFreeAmount: true,
};
